"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartTimeEndTimeComponent = void 0;
/**
 * Created by nchenglie on 1/12/2017.
 */
var React = require("react");
var TimePicker_1 = require("./controls/TimePicker");
var SelfServiceSchedulePane_1 = require("./SelfServiceSchedulePane");
var StartTimeEndTimeComponent = /** @class */ (function (_super) {
    __extends(StartTimeEndTimeComponent, _super);
    function StartTimeEndTimeComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.startTimeChangeHandler = function (time) { _this.startTimeChangedInternal(time); };
        _this.endTimeChangeHandler = function (time) { _this.endTimeChangedInternal(time); };
        return _this;
    }
    StartTimeEndTimeComponent.prototype.startTimeChangedInternal = function (time) {
        this.props.onStartTimeChange(time);
    };
    StartTimeEndTimeComponent.prototype.endTimeChangedInternal = function (time) {
        this.props.onEndTimeChange(time);
    };
    StartTimeEndTimeComponent.prototype.render = function () {
        var isFlowRunTaskPaneType = this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.FlowRunTask;
        return (React.createElement(React.Fragment, null,
            React.createElement(TimePicker_1.TimePicker, { testCaptionId: this.props.testStartCaptionId, caption: this.props.startCaption, testSelectId: this.props.testStartSelectId || 'startTimeSelectDefaultTestId', onTimeChange: this.startTimeChangeHandler, selectedValue: this.props.selectedStartValue, type: this.props.type, style: this.props.startStyle, minuteInterval: this.props.minuteInterval }),
            (!isFlowRunTaskPaneType || !this.props.shouldOnlyShowAtField) &&
                React.createElement(TimePicker_1.TimePicker, { testCaptionId: this.props.testEndCaptionId, caption: this.props.endCaption, testSelectId: this.props.testEndSelectId || 'endTimeSelectDefaultTestId', onTimeChange: this.endTimeChangeHandler, selectedValue: this.props.selectedEndValue, startFrom: !this.props.allowOvernight && this.props.selectedStartValue, type: this.props.type, style: this.props.endStyle, minuteInterval: this.props.minuteInterval })));
    };
    return StartTimeEndTimeComponent;
}(React.Component));
exports.StartTimeEndTimeComponent = StartTimeEndTimeComponent;
//# sourceMappingURL=StartTimeEndTimeComponent.js.map